import { render, staticRenderFns } from "./PartsCatalogueListSideMenu.vue?vue&type=template&id=84e4d444&scoped=true"
import script from "./PartsCatalogueListSideMenu.vue?vue&type=script&lang=js"
export * from "./PartsCatalogueListSideMenu.vue?vue&type=script&lang=js"
import style0 from "./PartsCatalogueListSideMenu.vue?vue&type=style&index=0&id=84e4d444&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e4d444",
  null
  
)

export default component.exports